export default __webpack_public_path__ + "static/media/bar-plus.297c2e23.svg";